import { mutationNames } from '@/store/storeKey'
import api from '@/modules/api'
import * as storage from '@/modules/storage'
import { getDefaultOrBrowserLanguage } from '@/modules/helper/index'
import moment from 'moment'

const state = {
  language: storage.language.get(),
  locale: storage.locale.get(),
  resource: storage.resource.get() || {}
}

const getters = {
  language: state => state.language,
  locale: state => state.locale,
  resource: state => state.resource
}

const mutations = {

  [mutationNames.SET_LANGUAGE] (state, language) {
    state.language = language
  },

  [mutationNames.SET_RESOURCE] (state, resource) {
    state.resource = resource
  }

}

const actions = {

  setLanguage ({ commit }, language) {
    storage.language.set(language)
    commit(mutationNames.SET_LANGUAGE, language)
  },

  async loadResource ({ commit, getters }, lng) {
    // let sLanguage = storage.language.get()
    // let sLocale = storage.locale.get()
    // if (!sLanguage || !sLocale) {
    //   const { language, locale } = getDefaultOrBrowserLanguage('de')
    //   storage.language.set(language)
    //   storage.locale.set(locale)
    //   lng = language
    // }
    const { language, locale } = getDefaultOrBrowserLanguage('de')
    storage.language.set(language)
    storage.locale.set(locale)
    lng = language

    if (lng && lng !== getters.language) {
      const resource = await api.system.getResource(lng, moment().unix())
      storage.language.set(lng)
      storage.resource.set(resource)
      commit(mutationNames.SET_LANGUAGE, lng)
      commit(mutationNames.SET_RESOURCE, resource)
    } else {
      let resource = storage.resource.get()
      if (!resource) {
        resource = await api.system.getResource(getters.language, moment().unix())
        storage.resource.set(resource)
      }
      commit(mutationNames.SET_RESOURCE, resource)
    }
  }

}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/resource.js